import { AbstractApiClient } from "../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../AbstractApiClient/IApiResponse";
import {
  getNewHireReportingSummary,
  ISummaryItem,
} from "./routes/getNewHireReportingSummary";
import { getNewHireWorkers, IWorkerRecord } from "./routes/getNewHireWorkers";
import {
  updateNewHireWorkerStatus,
  IUpdateNewHireWorkerStatusRequest,
} from "./routes/updateNewHireWorkerStatus";
import {
  generateNewHireFileUrl,
  IGenerateNewHireFileUrlRequest,
  IGenerateNewHireFileUrlResponse,
} from "./routes/generateNewHireFileUrl";

export interface IUhuraClient {
  GetNewHireReportingSummary(params: {
    start_date?: string;
    end_date?: string;
  }): Promise<IApiResponse<ISummaryItem[]>>;
  GetNewHireWorkers(params: {
    sent_date: string;
    state: string;
  }): Promise<IApiResponse<IWorkerRecord[]>>;
  UpdateNewHireWorkerStatus(
    worker_id: string,
    data: IUpdateNewHireWorkerStatusRequest
  ): Promise<IApiResponse<any>>;
  GenerateNewHireFileUrl(
    params: IGenerateNewHireFileUrlRequest
  ): Promise<IApiResponse<IGenerateNewHireFileUrlResponse>>;
}

export class UhuraClient extends AbstractApiClient implements IUhuraClient {
  public readonly GetNewHireReportingSummary = getNewHireReportingSummary(
    this.Instance
  );
  public readonly GetNewHireWorkers = getNewHireWorkers(this.Instance);
  public readonly UpdateNewHireWorkerStatus = updateNewHireWorkerStatus(
    this.Instance
  );
  public readonly GenerateNewHireFileUrl = generateNewHireFileUrl(
    this.Instance
  );
}
